<template>
  <div>
    <purchase-call :purchase="purchase">
      <template slot="actions">
        <v-btn
          v-if="isPending && canAccept"
          class="ml-3"
          @click.native.stop="accept({ id: purchase.id })"
          primary light
          :loading="loading">
          {{ $t('purchase.appointment.accept') }}
        </v-btn>
        <purchase-refund
          :title="$t('purchase.appointment.refund')"
          :purchase="purchase">
        </purchase-refund>
      </template>
    </purchase-call>
  </div>
</template>

<script>
  import purchase from '@/mixins/purchase'
  import PurchaseCall from './Call'
  import PurchaseRefund from './Refund'
  export default {
    components: {
      PurchaseCall,
      PurchaseRefund
    },
    mixins: [purchase],
    computed: {
      canAccept () {
        return this.purchase.service.creator_type === 'User'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/purchase/Appointment.vue